import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const o = t((e, r) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: r,
    ...e,
    image: (c) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...c,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4129",
              width: 33,
              height: 33,
              x: 8,
              y: 7,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M39.92 12.64c0-2.86-1.18-4.64-3.09-4.64-1.93 0-2.91 1.56-2.91 4.63 0 3.12-.9 3.12-1.19 3.12-.94 0-1.49-.51-1.49-3.12 0-4.04-1.8-4.64-2.87-4.64-1.46 0-3.21.81-3.21 4.64 0 2.67-.43 3.12-1.38 3.12-.42 0-1.54 0-1.54-3.12C22.26 8.45 20.2 8 19.31 8c-2.02 0-3.05 1.56-3.05 4.64 0 2.91-.5 3.14-1.11 3.14-.42 0-1.29 0-1.29-3.14 0-1.27 0-4.64-2.88-4.64C9.87 8 8 8.6 8 12.64v3.87c0 .41.34.75.75.75s.75-.34.75-.75v-3.87c0-2.08.5-3.14 1.48-3.14.7 0 1.38.24 1.38 3.14 0 1.15 0 4.64 2.79 4.64 2.61 0 2.61-3.02 2.61-4.64 0-3.14 1.05-3.14 1.55-3.14 1.3 0 1.44 2.2 1.44 3.14 0 3.82 1.65 4.62 3.04 4.62 2.88 0 2.88-3 2.88-4.62 0-3.14 1.24-3.14 1.71-3.14 1.19 0 1.37 1.97 1.37 3.14 0 1.38 0 4.62 2.99 4.62 2.69 0 2.69-3.48 2.69-4.62 0-3.13.99-3.13 1.41-3.13 1.47 0 1.59 2.41 1.59 3.14 0 1.82.08 3.87.08 3.89.02.41.37.76.78.72a.75.75 0 0 0 .72-.78c-.01-.02-.09-2.04-.09-3.84M24 36.14c1.51 0 4.64 0 4.64-2.55 0-2.4-2.57-2.4-4.64-2.4-2.9 0-3.14-.61-3.14-1.29 0-.39 0-1.19 3.14-1.19 3.06 0 4.62-.93 4.62-2.77 0-2.64-3-2.64-4.62-2.64-3.14 0-3.14-.79-3.14-1.21 0-.89 1.06-1.33 3.14-1.33h3.87c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H24c-3.84 0-4.64 1.54-4.64 2.83 0 2.71 3.25 2.71 4.64 2.71 2.63 0 3.12.38 3.12 1.14 0 .32 0 1.27-3.12 1.27-1.27 0-4.64 0-4.64 2.69 0 2.79 3.25 2.79 4.64 2.79 2.53 0 3.14.18 3.14.9 0 .51-.24 1.05-3.14 1.05-3.08 0-4.64.89-4.64 2.63 0 1.24.81 2.73 4.64 2.73h3.87c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H24c-1.17 0-3.14-.16-3.14-1.23 0-.75 1.05-1.13 3.14-1.13"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4129)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M1.186 1.238h46.73v46.73H1.186z" }) })
        ]
      }
    )
  }
));
o.displayName = "AgencyTextureIcon";
export {
  o as AgencyTextureIcon,
  o as default
};
//# sourceMappingURL=index.js.map
